// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nf-5";
export var filledCircle = "_nf-4";
export var historyEntry = "_nf-3";
export var messageSideLeft = "_nf-1";
export var messageSideRight = "_nf-2";
export var orderTrackingCarouselWrapper = "_nf-6";
export var orderTrackingInfoContainer = "_nf-0";